import { createFileRoute, redirect } from '@tanstack/react-router';

// Redirect /auth to the main landing page
export const Route = createFileRoute('/auth/')({
  beforeLoad: () => {
    throw redirect({ to: '/', search: { hero: undefined } });
  },
  component: () => null,
});
